module.exports = __webpack_public_path__ + "img/0060.8526c576.jpg";